import React from "react";
import CitiesView from "../../../views/dashboard/cities";

const Cities = () => {
  return <CitiesView />;
};

export default Cities;
